export default __webpack_public_path__ + "static/media/5000_en.00ff2604.ods";